module.exports = __webpack_public_path__ + "img/next_to_coast_hillside.6f899df7.jpg";